<template>
  <div class="wrapper">
    <div class="hearder_wrapper">
      <div class="title">
        <div class="select_date" v-if="isEdit">选择日期</div>
        <div class="select_date" v-if="!isEdit">日期</div>
        <div v-if="isEdit">
          <div
            v-show="playDateNum != totalPlayDateNum || getFramesSelectNum() == 0"
            class="all_select"
            :class="{ cannot_class: isCannot() }"
            @click="checkeAll"
          >
            全选
          </div>
          <div
            v-show="playDateNum == totalPlayDateNum && getFramesSelectNum() > 0"
            class="deselect_all"
            @click="deselectAll"
          >
            取消全选
          </div>
        </div>
      </div>
    </div>
    <div class="connent_wrapper">
      <ul class="week_wrapper">
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li>六</li>
        <li>日</li>
      </ul>
      <div class="calendre_wrapper">
        <calendreItem
          v-for="(item, index) in dateArray"
          :key="index"
          :title="item"
          :beginTime="bTime"
          :endTime="eTime"
          :isEdit="isEditProps"
          ref="child"
        />
      </div>
    </div>
  </div>
</template>

<script>
import calendreItem from './calendreItem.vue'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    calendreItem
  },
  data() {
    return {
      dateArray: '', //年月集合 ["2021-06", "2021-07", "2021-08"]
      bTime: '',
      eTime: '',
      isEditProps: false,
      currentFramesSelectNum: 0 //当前画面选择的日期个数
    }
  },
  computed: {
    ...mapState(['totalPlayDateNum', 'playDateNum', 'framesList'])
  },
  props: {
    beginTime: String,
    endTime: String,
    isEdit: Boolean
  },
  watch: {
    isEdit: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.isEditProps = newVal
      },
      immediate: true
    },
    beginTime: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.bTime = newVal
      },
      immediate: true
    },
    endTime: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.eTime = newVal
      },
      immediate: true
    }
  },
  created() {
    this.resetPlayDateNum() //清空总天数重新计算
    // this.isEditProps = this.isEdit
    // this.bTime = this.beginTime
    // this.eTime = this.endTime
    //将排期日期转换为可以渲染的数据
    this.dateArray = this.getDiffList(this.bTime, this.eTime, 'months')
  },
  methods: {
    ...mapMutations(['resetPlayDateNum']),
    //获取两日期之间日期列表函数
    getDiffList(beginTime, endTime, type) {
      //对年月日处理成年月moment(currentDate).format('YYYY-MM')
      let bTime = moment(beginTime).format('YYYY-MM')
      let eTime = moment(endTime).format('YYYY-MM')
      var dateArray = [] // dateArray 起止日期中间的所有日期列表
      var currentDate = moment(bTime) //起止日期
      var stopDate = moment(eTime) //截止日期
      //开始日期小于等于结束日期,并循环
      while (currentDate <= stopDate) {
        if (type === 'days') dateArray.push(moment(currentDate).format('YYYY-MM-DD')) //两个日期间的所有日期
        if (type === 'months') dateArray.push(moment(currentDate).format('YYYY-MM')) //两个月份间的所有月份
        if (type === 'years') dateArray.push(moment(currentDate).format('YYYY')) //两个年份间的所有年份
        currentDate = moment(currentDate).add(1, type) //根据类型+1
      }
      return dateArray
    },
    //全选所有未选择日期都变为已选择
    checkeAll() {
      //判断是否选择画面
      if (!this.isCheckFrames()) {
        return this.$message.warning('请选择画面')
      }
      this.$refs.child.forEach(item => {
        item.checkeAll()
      })
    },
    //取消全选
    deselectAll() {
      //判断是否选择画面
      if (!this.isCheckFrames()) {
        return this.$message.warning('请选择画面')
      }
      this.$refs.child.forEach(item => {
        item.deselectAll()
      })
    },
    //判断是否选择画面
    isCheckFrames() {
      return this.framesList.find(item => {
        return item.checked
      })
    },
    getFramesSelectNum() {
      let arr = this.framesList.filter(item => {
        return item.checked
      })
      //避免选中的画面被删除后报错
      let num = arr.length ? arr[0].playDates.length : 0
      return num
    },
    isCannot() {
      if (this.playDateNum == this.totalPlayDateNum && this.getFramesSelectNum() == 0) {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .hearder_wrapper {
    .title {
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      align-items: center;
      height: 54px;
      border-bottom: 1px solid #e9e9e9;
      .select_date {
        width: 64px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
      }
      .all_select,
      .deselect_all {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1890ff;
        line-height: 20px;
        cursor: pointer;
        user-select: none;
      }
      .cannot_class {
        color: rgba(0, 0, 0, 0.43);
      }
    }
  }
  .connent_wrapper {
    .week_wrapper {
      display: flex;
      justify-content: space-between;
      padding: 0 17px;
      border-bottom: 1px solid #e9e9e9;
      li {
        height: 32px;
        width: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .calendre_wrapper {
      height: 429px;
      overflow-y: hidden;
      &:hover {
        overflow-y: auto;
      }
    }
  }
}
</style>
